export default __webpack_public_path__ + "static/media/follow-dark-grey.42dcb637.svg";